import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { di } from '../../state/inversify.config';
import { Assessment } from '../../state/reduxRepositories/assessments/assessments.interfaces';
import { getRouteByAccountType } from '../../routes/getRouteByAccountType';
import { ViewIncidentDomainService } from './viewIncidentDomainService';
import { AuthService } from '../../state/helperServices/auth/auth.service';
import { dateTime } from '../../time/datetime';
import { Collapsible } from '../../components/collapsible/collapsible';
import { Button } from '../../components/button/button';

export function Reports() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const viewIncidentDomainService = di.get<ViewIncidentDomainService>(
    ViewIncidentDomainService,
  );
  const assessments =
    viewIncidentDomainService.useSelectedClearanceAssessmentSelector();

  // TODO: move into viewIncidentDomainService and only return accountType or even better create a shared navigation service so we don't have to return accountType to all components that needs navigation (or similar)
  const authService = di.get<AuthService>(AuthService);
  const user = authService.useLoggedInUserSelector();

  const selectAssessment = (id: string) => {
    navigate(
      `/${getRouteByAccountType(
        user?.accountType,
      )}/assessment-history?selectedAssessmentId=${id}`,
    );
  };

  return (
    <Collapsible title={t('MEDICAL_CLEARANCE')}>
      <Grid>
        <Grid item>
          <Typography id="view-past-assessments-title" variant="body1">
            {t('PAST_ASSESSMENTS')}
          </Typography>
        </Grid>
        <Grid item>
          <ul>
            {assessments.map((assessment: Assessment, i: number) => (
              <li key={assessment.id}>
                <Button
                  type="submit"
                  variant="text"
                  size="small"
                  onClick={() => selectAssessment(assessment.id)}
                  label={`Assessment ${
                    assessments.length - i
                  }: ${dateTime.format(
                    assessment.createdAt,
                    t('common.datetime.FORMAT_SHORT_DATE'),
                  )}`}
                />
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>
    </Collapsible>
  );
}
